<mat-dialog-content>{{data.message | translate}}</mat-dialog-content>
<mat-dialog-content><b class="content">{{data.name | translate}}</b></mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="cancelbtn gradient-btn-o btn" (click) = "onNoClick()">{{ 'myprofile.myaddress.label.cancel' | translate}}</button>
    <button class="yesbtn" (click) = "onYesClick()">{{ 'myprofile.myaddress.label.proceed' | translate}}</button>
</mat-dialog-actions>
